module.exports = __webpack_public_path__ + "img/暂无比赛成绩@2x.8f98d59f.png";